import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
const services = [{
  title: 'Оскарження штрафу ТЦК',
  desc: 'Аналіз правомірності накладення штрафу, підготовка скарги та повне представництво у суді.'
}, {
  title: 'Отримання відстрочки',
  desc: 'Збір пакету документів, підготовка аргументованої заяви та юридичний супровід процесу.'
}, {
  title: 'Виключення з обліку',
  desc: "Супровід процедури виключення з військового обліку за станом здоров'я або іншими підставами."
}, {
  title: 'Оскарження рішень ВЛК',
  desc: 'Допомога в оскарженні неправомірних висновків комісії до Центральної ВЛК або в суді.'
}, {
  title: 'Звільнення зі служби',
  desc: 'Консультації та підготовка рапортів для законного звільнення з лав ЗСУ.'
}, {
  title: 'Переведення у іншу ВЧ',
  desc: 'Юридична допомога в правильному оформленні відношення та рапорту на переведення.'
}, {
  title: 'Виплати військовим',
  desc: "Допомога в отриманні ОГД за поранення, інвалідність, а також виплат сім'ям загиблих."
}, {
  title: 'Захист при СЗЧ',
  desc: 'Професійний захист у кримінальних провадженнях щодо самовільного залишення частини.'
}, {
  title: 'Статус УБД',
  desc: 'Допомога у зборі доказів участі в бойових діях та супровід процедури отримання статусу.'
}, {
  title: 'Індексація виплат',
  desc: 'Перерахунок та стягнення недоплаченого грошового забезпечення через суд.'
}];
export function Services() {
  return <section id="services" className="bg-[#F4F4F5]" data-id="element-85">
      <div className="max-w-[1400px] mx-auto px-6 py-24" data-id="element-86">
        <div className="mb-16" data-id="element-87">
          <h2 className="text-5xl lg:text-7xl font-bold tracking-tight" data-id="element-88">
            СПЕКТР ПОСЛУГ
          </h2>
        </div>

        <div className="border-t-2 border-black" data-id="element-89">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="group flex flex-col md:flex-row border-b-2 border-black hover:bg-black hover:text-white transition-colors cursor-pointer" data-id="element-90">
              <div className="md:w-1/3 p-6 md:p-8 border-b-2 md:border-b-0 md:border-r-2 border-black group-hover:border-white transition-colors" data-id="element-91">
                <span className="text-sm font-bold uppercase tracking-widest block mb-2 opacity-50" data-id="element-92">
                  0{index + 1}
                </span>
                <h3 className="text-2xl lg:text-3xl font-bold" data-id="element-93">
                  {service.title}
                </h3>
              </div>
              <div className="md:w-2/3 p-6 md:p-8 flex items-center justify-between" data-id="element-94">
                <p className="text-lg font-medium max-w-2xl" data-id="element-95">{service.desc}</p>
                <ArrowRight className="w-8 h-8 hidden md:block opacity-0 group-hover:opacity-100 transform -translate-x-4 group-hover:translate-x-0 transition-all" data-id="element-96" />
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}